import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import ClientBudgetsTable from "./components/ClientBudgetsTable";
import PageWrapper from "app/modules/shared/PageWrapper";

const ClientBudgetsTablePage: React.FC = () => {
  return (
    <CPLAnalytics pageName="Client Budgets">
      <PageWrapper data-test-id="budgets-page__back-button" title="Budgets" backTo="/accounts">
        <ClientBudgetsTable />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default ClientBudgetsTablePage;
